const Card = ({ children, className = '', ...props }) => (
  <div {...props} className={`${className || ''} card`}>
    <div className="card-body">{children}</div>
  </div>
)
export default Card
